export default __webpack_public_path__ + "static/media/section2-guide-bar-h5.67d73d9d.png";